import { render, staticRenderFns } from "./StartCar.vue?vue&type=template&id=599806e0&scoped=true&"
import script from "./StartCar.vue?vue&type=script&lang=js&"
export * from "./StartCar.vue?vue&type=script&lang=js&"
import style0 from "./StartCar.vue?vue&type=style&index=0&id=599806e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599806e0",
  null
  
)

export default component.exports